import { get, getTrackingString } from '../../utils/object-helpers';
import storeEvent from '../../utils/store-event';

export default class {
    onCreate(input) {
        const catMod = get(input, 'page.modules.STORE_CATEGORIES_MODULE', {});
        this.trackIsOpen = getTrackingString(catMod, 'toggle.onCallToAction.action.trackingList');
        this.trackIsClosed = getTrackingString(catMod, 'toggle.offCallToAction.action.trackingList');
        const isInitialStateOff = get(catMod, 'toggle.initialState', '') === 'OFF';
        const labelClass = input.hideLabel ? 'clipped' : '';

        this.state = {
            ariaExpanded: isInitialStateOff ? 'false' : 'true',
            tracking: isInitialStateOff ? this.trackIsClosed : this.trackIsOpen,
            ariaLabel: get(catMod, 'label', ''),
            showLabel: get(catMod, 'toggle.offCallToAction.text', ''),
            hideLabel: get(catMod, 'toggle.onCallToAction.text', ''),
            hasCategories: !!get(catMod, 'categories', false),
            a11yTitle: get(catMod, 'title.text', 'Filter by category'),
            labelClass
        };
    }
    onMount() {
        storeEvent.toggleLeftNavDone.listen(data => {
            this.state.ariaExpanded = `${data.isOpen}`; // Needs to be string
            this.state.tracking = data.isOpen ? this.trackIsOpen : this.trackIsClosed;
        });
    }
    toggleLeftNav() {
        storeEvent.toggleLeftNav.dispatch();
    }
}
